var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddPhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 22,
    viewBox: "0 0 42 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 27,
    height: 22,
    x: 15,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 22,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fontSize: 0,
    style: {
      whiteSpace: "pre"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1.055,
    y: 17,
    fill: "rgb(24,35,38)",
    fontFamily: "SF Pro Text",
    fontSize: 15,
    fontWeight: 600,
    style: {
      whiteSpace: "pre",
      textTransform: "none"
    },
    letterSpacing: -0.24
  }, "+")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(24,35,38)",
    fillRule: "evenodd",
    d: "M24.3656311 0c-.421875 0-.75938415.25482178-.84375.5946045l-.84375 2.5482788h-4.640625C16.3500061 3.1428833 15 4.58685303 15 6.20074463v12.741333C15 20.64093019 16.3500061 22 18.0375061 22H39.046875c1.6875 0 3.0375061-1.35906982 3.0375061-3.05792236V6.20074463c0-1.6987915-1.3500061-3.05786133-3.0375061-3.05786133h-5.65312195l-.84375-2.5482788C32.46562195.25482177 32.04374695 0 31.70625305 0H24.3656311zm.59062195 1.78381348H31.03125l.84375 2.5482788c.08436584.33978272.50624084.5946045.84375.5946045h6.328125c.67500305 0 1.1812439.50964355 1.1812439 1.18914795v12.741333c0 .6795044-.50624085 1.18920899-1.1812439 1.18920899H18.03749084c-.67498779 0-1.1812439-.5097046-1.1812439-1.18920899v-12.741333c0-.6795044.50625611-1.18914795 1.1812439-1.18914795h5.31562806c.421875 0 .75938415-.25482178.84375-.5946045l.75938415-2.5482788zM34.9125061 7.3050537c0-.50970459.421875-.9343872.9281311-.9343872h2.109375c.50624085 0 .92811585.42468261.92811585.9343872 0 .50964356-.421875.93432617-.92811584.93432617h-2.109375c-.5062561 0-.9281311-.42468261-.9281311-.93432617zm-11.9812622 5.26641846c0-3.05792237 2.53125-5.60620117 5.5687561-5.60620117 3.03749084 0 5.56874084 2.5482788 5.56874084 5.60620117 0 3.05792236-2.53125 5.60614013-5.56874084 5.60614013-3.0375061 0-5.5687561-2.54821777-5.5687561-5.60614013zM28.5 8.74902344c2.109375 0 3.796875 1.69885254 3.796875 3.8223877 0 2.12353515-1.6875 3.82238769-3.796875 3.82238769s-3.796875-1.69885254-3.796875-3.8223877c0-2.12353515 1.6875-3.8223877 3.796875-3.8223877z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhoto);
export default __webpack_public_path__ + "static/media/add_photo.5880771a0ebd108c434d28b910dbd1e0.svg";
export { ForwardRef as ReactComponent };